<div class="schema-container">
  <!-- Context Menu -->
  <ejs-contextmenu
    #contextMenu
    [items]="menuItems"
    (select)="onContextMenuSelect($event)"
    cssClass="schema-context-menu">
  </ejs-contextmenu>

  <!-- Header Bar -->
  <div class="header-bar">
    <div class="filter-dropdown">
      <select
        class="filter-select"
        [(ngModel)]="objectTypeFilter"
        (change)="applyFilters()"
      >
        <option [value]="ObjectTypeFilter.All">All Objects</option>
        <option [value]="ObjectTypeFilter.Table">Tables</option>
        <option [value]="ObjectTypeFilter.View">Views</option>
      </select>
      <i class="fa fa-chevron-down dropdown-icon"></i>
    </div>

    <div class="search-container">
      <i class="fa fa-search search-icon"></i>
      <input
        type="text"
        class="search-input"
        placeholder="Search tables..."
        [(ngModel)]="searchTerm"
        (input)="searchSchema()"
      />
      @if (searchTerm) {
        <button class="clear-search" (click)="clearSearch()" title="Clear search">
          <i class="fa fa-times"></i>
        </button>
      }
    </div>
  </div>

  <!-- Loading Spinner -->
  @if (isLoading) {
    <div class="loading-container">
      <div class="spinner"></div>
      <span>Loading schema...</span>
    </div>
  }

  <!-- Tree View -->
  <div class="tree-container">
    @for (node of treeNodes; track node.id) {
      <div class="tree-node">
        <!-- AppObject Node -->
        <div
          class="node-item object-node"
          [class.expanded]="node.isExpanded"
          (click)="toggleNode(node)"
        >
          <i class="fa fa-chevron-right chevron"></i>
          <span
            class="table-name-draggable"
            draggable="true"
            (dragstart)="onTableDragStart($event, node)"
            (dragend)="onTableDragEnd($event)"
            (contextmenu)="onTableContextMenu($event, node)"
          >
            <span class="node-name object-name">{{ node.displayName }} <span class="field-count">({{ node.fieldCount }})</span></span>
            @if (node.objectType === 2) {
              <span class="object-type-badge">View</span>
            }
          </span>
        </div>

        <!-- Fields -->
        @if (node.isExpanded && node.children) {
          <div class="children-container">
            @for (field of node.children; track field.id) {
              <div
                class="node-item field-node"
                draggable="true"
                (dragstart)="onFieldDragStart($event, field)"
                (dragend)="onFieldDragEnd($event)"
                (contextmenu)="onFieldContextMenu($event, field, node)"
                [title]="field.tooltip || ''"
              >
                <span class="node-icon field-icon">{{ field.icon }}</span>
                <span class="node-name field-name">{{ field.name }}</span>
                <span class="field-type">{{ field.dataType }}</span>
                @if (field.isLookup && field.lookupTarget) {
                  <span class="lookup-arrow">→ {{ field.lookupTarget }}</span>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  <!-- Empty State -->
  @if (!isLoading && treeNodes.length === 0) {
    <div class="empty-state">
      <span class="empty-icon">📭</span>
      <span>No schema data found</span>
    </div>
  }
</div>

